export default __webpack_public_path__ + "static/Row 2.1_British Council-8308b5b500394d223c49ac94bd0f1181.jpg";